import { UseCases } from "@aptus/frontend-core";
import { Events } from "event";
import { useEffect, useState } from "react";
import { getConsent, loadClarity, setConsent } from "utils/analytics";

interface Result {
	shouldShowCookieConsentBanner: boolean;
	cookiePolicyURL: string;

	acceptCookies: Events["acceptCookies"];
	rejectCookies: Events["rejectCookies"];
}

const FALLBACK_WEBSITE_HOST = "www.ikhighfive.be";

/**
 * This app has no cookie policy page of its own, so point at the marketing
 * website's one. Derived from the host so .nl visitors get the .nl policy.
 */
const getCookiePolicyURL: () => string = () => {
	// leerling.ikhighfive.be -> ikhighfive.be, dev.leerling.ikhighfive.nl -> dev.ikhighfive.nl
	const host = window.location.host.replace("leerling.", "");
	const websiteHost = host.endsWith("ikhighfive.be") || host.endsWith("ikhighfive.nl") ? host : FALLBACK_WEBSITE_HOST;

	return `https://${websiteHost}/cookies`;
};

export const useCookieConsentUseCases: UseCases<undefined, Result> = () => {
	const [shouldShowCookieConsentBanner, setShouldShowCookieConsentBanner] = useState<Result["shouldShowCookieConsentBanner"]>(false);

	const enableAnalytics: () => void = () => {
		loadClarity(window?.appEnvironment?.CLARITY_PROJECT_ID);
	};

	const acceptCookies: Result["acceptCookies"] = () => {
		setConsent("granted");
		enableAnalytics();
		setShouldShowCookieConsentBanner(false);
	};

	const rejectCookies: Result["rejectCookies"] = () => {
		setConsent("denied");
		setShouldShowCookieConsentBanner(false);
	};

	useEffect(() => {
		const choice = getConsent();

		if (choice === "granted") {
			enableAnalytics();
			return;
		}

		if (choice === null) {
			setShouldShowCookieConsentBanner(true);
		}
	}, []);

	return {
		shouldShowCookieConsentBanner,
		cookiePolicyURL: getCookiePolicyURL(),
		acceptCookies,
		rejectCookies,
	};
};
